/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_3_TitleInputs */

const en_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winner of numerous additional Iowa PGA events`)
};

const es_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganador de muchos otros torneos de la Iowa PGA`)
};

const de_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieger zahlreicher weiterer Turniere der Iowa PGA`)
};

const zh_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多项其他 Iowa PGA 赛事冠军得主`)
};

const ar_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفائز بالعديد من فعاليات Iowa PGA الأخرى`)
};

const fr_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vainqueur de nombreux autres tournois de la Iowa PGA`)
};

const vi_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch nhiều giải đấu Iowa PGA khác`)
};

const sw_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mshindi wa mashindano mengine mengi ya Iowa PGA`)
};

const th_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ชนะรายการอื่นๆ ของ Iowa PGA อีกมากมาย`)
};

const bs_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobjednik brojnih drugih turnira Iowa PGA`)
};

const ja_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他多数のIowa PGA大会で優勝`)
};

const ko_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 밖의 여러 Iowa PGA 대회 우승`)
};

const pt_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencedor de inúmeros outros torneios da Iowa PGA`)
};

const it_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincitore di numerosi altri tornei della Iowa PGA`)
};

const sv_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinnare av ett flertal andra tävlingar i Iowa PGA`)
};

const nl_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winnaar van talrijke andere toernooien van de Iowa PGA`)
};

const da_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinder af mange andre turneringer i Iowa PGA`)
};

const nb_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinner av en rekke andre turneringer i Iowa PGA`)
};

const fi_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukuisten muiden Iowa PGA:n turnausten voittaja`)
};

const pl_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwycięzca wielu innych turniejów Iowa PGA`)
};

const ru_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Победитель многих других турниров Iowa PGA`)
};

const tr_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok sayıda başka Iowa PGA turnuvasının galibi`)
};

const hi_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA के कई अन्य टूर्नामेंटों के विजेता`)
};

const id_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemenang banyak turnamen Iowa PGA lainnya`)
};

const ms_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemenang banyak kejohanan Iowa PGA yang lain`)
};

const cs_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vítěz mnoha dalších turnajů Iowa PGA`)
};

const el_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νικητής πολλών ακόμη τουρνουά της Iowa PGA`)
};

const he_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`זוכה במספר רב של תחרויות Iowa PGA נוספות`)
};

const af_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenner van talle ander Iowa PGA-toernooie`)
};

const hu_about_content_competitive_3_title = /** @type {(inputs: About_Content_Competitive_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Számos további Iowa PGA verseny győztese`)
};

/**
* | output |
* | --- |
* | "Winner of numerous additional Iowa PGA events" |
*
* @param {About_Content_Competitive_3_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_3_title = /** @type {((inputs?: About_Content_Competitive_3_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_3_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_3_title(inputs)
	if (locale === "de") return de_about_content_competitive_3_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_3_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_3_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_3_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_3_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_3_title(inputs)
	if (locale === "th") return th_about_content_competitive_3_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_3_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_3_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_3_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_3_title(inputs)
	if (locale === "it") return it_about_content_competitive_3_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_3_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_3_title(inputs)
	if (locale === "da") return da_about_content_competitive_3_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_3_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_3_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_3_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_3_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_3_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_3_title(inputs)
	if (locale === "id") return id_about_content_competitive_3_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_3_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_3_title(inputs)
	if (locale === "el") return el_about_content_competitive_3_title(inputs)
	if (locale === "he") return he_about_content_competitive_3_title(inputs)
	if (locale === "af") return af_about_content_competitive_3_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_3_title(inputs)
	return en_about_content_competitive_3_title(inputs)
});